export { default as FolderMoveOutlineIcon } from './FolderMoveOutlineIcon';
